// Páginas com layout de Impressão

const print = [
  {
    path: '/print',
    name: 'Impressão',
    component: () => import('@/view/Layouts/PrintContainer/PrintContainer.vue'),
    // Visualização/impressão de documentos (boleto, recibo, extrato) aberta em
    // nova aba a partir de painéis admin cross-cliente (Cash In, Cash Out); o
    // backend não depende do header Client pra servir esses dados (PR #1986).
    // Admin sem vínculo pode acessar.
    meta: {
      auth: true,
      adminUnlinked: true,
    },
    children: [
      {
        path: 'boleto/:id',
        name: 'Visualização de Boleto',
        component: () => import('@/view/pages/shared/printables/invoices/Boleto.vue'),
      },
      {
        path: 'carne/:id',
        name: 'Visualização de Carne',
        component: () => import('@/view/pages/shared/printables/invoices/Carne.vue'),
      },
      {
        path: 'account/deposit/:id',
        name: 'Contas - Depósitos -  Imprimir Boleto de Depósito',
        component: () => import('@/view/pages/shared/printables/invoices/Deposit.vue'),
      },
      {
        path: 'debenture/:id/print',
        name: 'Debenture - Extrato',
        component: () => import('@/view/pages/shared/printables/statement/DebentureStatement.vue'),
      },
      {
        path: 'receipt/:id',
        name: 'Imprimir Recibo',
        component: () => import('@/view/pages/shared/printables/receipts/Receipt.vue'),
      },
      {
        path: 'receipts/',
        name: 'Imprimir Lote Recibos',
        component: () => import('@/view/pages/shared/printables/receipts/BulkReceipt.vue'),
      },
      {
        path: '/admin/reports/dailyop',
        name: 'Admin - Relatórios - Visualizar Diario de Operacoes Digitais',
        component: () =>
          import('@/view/pages/shared/printables/statement/OperationsDailyStatement.vue'),
        meta: {
          auth: true,
          admin: true,
        },
      },
      {
        path: 'reports/print/irpf',
        name: 'Imprimir Declaração de Imposto de Renda',
        component: () => import('@/view/pages/shared/printables/reports/IRPF.vue'),
      },
      {
        path: 'debts/single/:id/',
        name: 'Créditos - Detalhes de Título - Impressão',
        component: () => import('@/view/pages/shared/printables/debts/SingleDetails.vue'),
      },
    ],
  },
]

export default print
